"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = isValidReferenceNumber;
// https://www.pangaliit.ee/settlements-and-standards/reference-number-of-the-invoice
const config_1 = require("../config");
const lodash_1 = require("lodash");
function isValidReferenceNumber(channel, input, options = { strict: false }) {
    if (!options.strict) {
        return isValidReferenceNumberBasic(input);
    }
    if (channel === config_1.CountryChannel.EE) {
        let xsum = 0;
        let cpos = 0;
        let tmp = 0;
        let r = 0;
        let acc = '';
        acc = isNaN(parseInt(input.substring(0, 2))) ? input.substring(6) : input;
        if (isNaN(parseFloat(acc)) || parseFloat(acc) === 0) {
            return false;
        }
        acc = acc.toString();
        for (r = acc.length - 2; r >= 0; r = r - 1) {
            tmp = parseInt(acc.substring(r, r + 1));
            cpos++;
            xsum = xsum + tmp * ({ 1: 7, 2: 3, 3: 1 }[cpos] ?? 0);
            cpos = cpos === 3 ? 0 : cpos;
        }
        xsum = (10 - (xsum % 10)) % 10;
        r = acc.length - 1;
        tmp = parseInt(acc.substring(r, r + 1));
        return tmp === xsum;
    }
    throw new Error('Unknown behaviour');
}
function isValidReferenceNumberBasic(input) {
    return (0, lodash_1.isString)(input) && !(0, lodash_1.isEmpty)(input.trim()) && input.length <= config_1.PAYMENTS_REFERENCE_MAX_LENGTH;
}
